
export default {
  name: 'CContentTitle'
}
